export default "__VITE_ASSET__CxYuk0ar__"